const TESTIMONIALS = [
  {
    initials: 'RM',
    name: 'Rajiv M.',
    role: 'Export Head, Indian Spice Brand',
    quote: 'Atlas gave us real visibility into the ANZ market within weeks. The data was unlike anything a traditional distributor could offer.',
    border: 'border-[#004aad]',
    bg: 'bg-[#004aad]',
  },
  {
    initials: 'PS',
    name: 'Priya S.',
    role: 'Founder, Indian Snacks Brand',
    quote: 'We went from zero to retail shelves in Sydney in under 60 days. The team knew exactly which stores, which pack sizes, and which price points worked.',
    border: 'border-amber-500',
    bg: 'bg-amber-500',
  },
  {
    initials: 'AK',
    name: 'Amit K.',
    role: 'MD, FMCG Export Division',
    quote: 'The Box of India consumer base was already buying our category. Atlas made the connection effortless.',
    border: 'border-green-500',
    bg: 'bg-green-500',
  },
];

export const Testimonials = () => (
  <section className="py-20 md:py-32 bg-white">
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">What Our Partners Say</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Real feedback from brands we've launched in Australia & New Zealand.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {TESTIMONIALS.map((t) => (
          <div key={t.initials} className={`bg-gray-50 rounded-2xl p-8 border-l-4 ${t.border} hover:shadow-xl transition-all duration-300 card-lift`}>
            <div className="flex items-center space-x-4 mb-6">
              <div className={`h-12 w-12 ${t.bg} rounded-full flex items-center justify-center text-white font-bold`}>
                {t.initials}
              </div>
              <div>
                <p className="font-bold text-gray-900">{t.name}</p>
                <p className="text-sm text-gray-600">{t.role}</p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed italic">"{t.quote}"</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
